import React from 'react';
import CanvasRenderer from '../CanvasRenderer';

export default function FlexContainer({ comp, onChildSelect, selectedChildId }) {
  const isRow = comp.type === 'flex_row';
  const children = comp.children || [];

  return (
    <div style={{
      display: 'flex',
      flexDirection: isRow ? 'row' : 'column',
      gap: comp.gap || 12,
      padding: 10,
      border: '1px dashed #CBD5E1',
      borderRadius: 8,
    }}>
      {children.length === 0 && (
        <div style={{
          width: '100%',
          height: 80,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#9CA3AF',
          border: '1px dashed #E2E5EA'
        }}>
          Add children
        </div>
      )}

      {children.map((child) => (
        <div
          key={child.id}
          onClick={(e) => {
            e.stopPropagation();
            onChildSelect(child.id);
          }}
          style={{
            border: selectedChildId === child.id
              ? '2px solid #2563EB'
              : '1px dashed #E2E5EA',
            borderRadius: 6,
            padding: 6,
            position: 'relative'
          }}
        >
          <CanvasRenderer comp={child} />
        </div>
      ))}
    </div>
  );
}